export default {
    methods: {
        isMobile() {
            // if (
            //     /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            //         navigator.userAgent
            //     )
            // ) {
            //     return true;
            // } else {
            //     return false;
            // }
            if( document.documentElement.clientWidth <= 768 ) {
                return true;
            }
            else {
                return false;
            }
        },
    }
};